/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { lpInspectionControllerAddWord } from '../fn/lp-inspection/lp-inspection-controller-add-word';
import { LpInspectionControllerAddWord$Params } from '../fn/lp-inspection/lp-inspection-controller-add-word';
import { lpInspectionControllerComplete } from '../fn/lp-inspection/lp-inspection-controller-complete';
import { LpInspectionControllerComplete$Params } from '../fn/lp-inspection/lp-inspection-controller-complete';
import { lpInspectionControllerCreate } from '../fn/lp-inspection/lp-inspection-controller-create';
import { LpInspectionControllerCreate$Params } from '../fn/lp-inspection/lp-inspection-controller-create';
import { lpInspectionControllerExit } from '../fn/lp-inspection/lp-inspection-controller-exit';
import { LpInspectionControllerExit$Params } from '../fn/lp-inspection/lp-inspection-controller-exit';
import { lpInspectionControllerFindAll } from '../fn/lp-inspection/lp-inspection-controller-find-all';
import { LpInspectionControllerFindAll$Params } from '../fn/lp-inspection/lp-inspection-controller-find-all';
import { lpInspectionControllerFindById } from '../fn/lp-inspection/lp-inspection-controller-find-by-id';
import { LpInspectionControllerFindById$Params } from '../fn/lp-inspection/lp-inspection-controller-find-by-id';
import { lpInspectionControllerGenerateReport } from '../fn/lp-inspection/lp-inspection-controller-generate-report';
import { LpInspectionControllerGenerateReport$Params } from '../fn/lp-inspection/lp-inspection-controller-generate-report';
import { lpInspectionControllerGetEvents } from '../fn/lp-inspection/lp-inspection-controller-get-events';
import { LpInspectionControllerGetEvents$Params } from '../fn/lp-inspection/lp-inspection-controller-get-events';
import { lpInspectionControllerGetMultiplePdfDocuments } from '../fn/lp-inspection/lp-inspection-controller-get-multiple-pdf-documents';
import { LpInspectionControllerGetMultiplePdfDocuments$Params } from '../fn/lp-inspection/lp-inspection-controller-get-multiple-pdf-documents';
import { lpInspectionControllerGetPcczScore } from '../fn/lp-inspection/lp-inspection-controller-get-pccz-score';
import { LpInspectionControllerGetPcczScore$Params } from '../fn/lp-inspection/lp-inspection-controller-get-pccz-score';
import { lpInspectionControllerGetStat } from '../fn/lp-inspection/lp-inspection-controller-get-stat';
import { LpInspectionControllerGetStat$Params } from '../fn/lp-inspection/lp-inspection-controller-get-stat';
import { lpInspectionControllerHeartbeat } from '../fn/lp-inspection/lp-inspection-controller-heartbeat';
import { LpInspectionControllerHeartbeat$Params } from '../fn/lp-inspection/lp-inspection-controller-heartbeat';
import { lpInspectionControllerInvalidateResults } from '../fn/lp-inspection/lp-inspection-controller-invalidate-results';
import { LpInspectionControllerInvalidateResults$Params } from '../fn/lp-inspection/lp-inspection-controller-invalidate-results';
import { lpInspectionControllerIsCompleteLp1 } from '../fn/lp-inspection/lp-inspection-controller-is-complete-lp-1';
import { LpInspectionControllerIsCompleteLp1$Params } from '../fn/lp-inspection/lp-inspection-controller-is-complete-lp-1';
import { lpInspectionControllerOverwrite } from '../fn/lp-inspection/lp-inspection-controller-overwrite';
import { LpInspectionControllerOverwrite$Params } from '../fn/lp-inspection/lp-inspection-controller-overwrite';
import { lpInspectionControllerReInspect } from '../fn/lp-inspection/lp-inspection-controller-re-inspect';
import { LpInspectionControllerReInspect$Params } from '../fn/lp-inspection/lp-inspection-controller-re-inspect';
import { lpInspectionControllerRestore } from '../fn/lp-inspection/lp-inspection-controller-restore';
import { LpInspectionControllerRestore$Params } from '../fn/lp-inspection/lp-inspection-controller-restore';
import { lpInspectionControllerSearchAll } from '../fn/lp-inspection/lp-inspection-controller-search-all';
import { LpInspectionControllerSearchAll$Params } from '../fn/lp-inspection/lp-inspection-controller-search-all';
import { lpInspectionControllerSearchOffsetByAdmin } from '../fn/lp-inspection/lp-inspection-controller-search-offset-by-admin';
import { LpInspectionControllerSearchOffsetByAdmin$Params } from '../fn/lp-inspection/lp-inspection-controller-search-offset-by-admin';
import { lpInspectionControllerSearchOffsetByUser } from '../fn/lp-inspection/lp-inspection-controller-search-offset-by-user';
import { LpInspectionControllerSearchOffsetByUser$Params } from '../fn/lp-inspection/lp-inspection-controller-search-offset-by-user';
import { lpInspectionControllerSearchSimpleOffsetByParent } from '../fn/lp-inspection/lp-inspection-controller-search-simple-offset-by-parent';
import { LpInspectionControllerSearchSimpleOffsetByParent$Params } from '../fn/lp-inspection/lp-inspection-controller-search-simple-offset-by-parent';
import { LpInspectionDto } from '../models/lp-inspection-dto';
import { LpInspectionSeriesItemDto } from '../models/lp-inspection-series-item-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { PcczScoreDto } from '../models/pccz-score-dto';

@Injectable({ providedIn: 'root' })
export class LpInspectionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `lpInspectionControllerGetEvents()` */
  static readonly LpInspectionControllerGetEventsPath = '/api/lp-inspection/{id}/events';

  /**
   * 검사 진행 상황 이벤트 스트림.
   *
   * 검사 진행 상황을 실시간으로 스트리밍합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerGetEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGetEvents$Response(params: LpInspectionControllerGetEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return lpInspectionControllerGetEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 진행 상황 이벤트 스트림.
   *
   * 검사 진행 상황을 실시간으로 스트리밍합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerGetEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGetEvents(params: LpInspectionControllerGetEvents$Params, context?: HttpContext): Observable<void> {
    return this.lpInspectionControllerGetEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerGetMultiplePdfDocuments()` */
  static readonly LpInspectionControllerGetMultiplePdfDocumentsPath = '/api/lp-inspection/pdfs';

  /**
   * 복수 검사 결과 PDF 압축 다운로드.
   *
   * 여러 개의 검사 결과를 PDF로 변환해 ZIP으로 압축하여 다운로드합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerGetMultiplePdfDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGetMultiplePdfDocuments$Response(params: LpInspectionControllerGetMultiplePdfDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return lpInspectionControllerGetMultiplePdfDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * 복수 검사 결과 PDF 압축 다운로드.
   *
   * 여러 개의 검사 결과를 PDF로 변환해 ZIP으로 압축하여 다운로드합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerGetMultiplePdfDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGetMultiplePdfDocuments(params: LpInspectionControllerGetMultiplePdfDocuments$Params, context?: HttpContext): Observable<void> {
    return this.lpInspectionControllerGetMultiplePdfDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerFindAll()` */
  static readonly LpInspectionControllerFindAllPath = '/api/lp-inspection/all';

  /**
   * 모든 LP검사 조회.
   *
   * 모든 LP검사를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerFindAll$Response(params?: LpInspectionControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LpInspectionDto>>> {
    return lpInspectionControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 LP검사 조회.
   *
   * 모든 LP검사를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerFindAll(params?: LpInspectionControllerFindAll$Params, context?: HttpContext): Observable<Array<LpInspectionDto>> {
    return this.lpInspectionControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LpInspectionDto>>): Array<LpInspectionDto> => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerSearchAll()` */
  static readonly LpInspectionControllerSearchAllPath = '/api/lp-inspection/search/all';

  /**
   * 모든 LP검사 검색.
   *
   * 모든 LP검사를 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerSearchAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerSearchAll$Response(params: LpInspectionControllerSearchAll$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return lpInspectionControllerSearchAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 LP검사 검색.
   *
   * 모든 LP검사를 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerSearchAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerSearchAll(params: LpInspectionControllerSearchAll$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.lpInspectionControllerSearchAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerSearchOffsetByAdmin()` */
  static readonly LpInspectionControllerSearchOffsetByAdminPath = '/api/lp-inspection/search/offset/admin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerSearchOffsetByAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerSearchOffsetByAdmin$Response(params: LpInspectionControllerSearchOffsetByAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}>> {
    return lpInspectionControllerSearchOffsetByAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerSearchOffsetByAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerSearchOffsetByAdmin(params: LpInspectionControllerSearchOffsetByAdmin$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}> {
    return this.lpInspectionControllerSearchOffsetByAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}>): OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
} => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerSearchOffsetByUser()` */
  static readonly LpInspectionControllerSearchOffsetByUserPath = '/api/lp-inspection/search/offset/user';

  /**
   * 선생님 LP검사 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerSearchOffsetByUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerSearchOffsetByUser$Response(params: LpInspectionControllerSearchOffsetByUser$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}>> {
    return lpInspectionControllerSearchOffsetByUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 선생님 LP검사 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerSearchOffsetByUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerSearchOffsetByUser(params: LpInspectionControllerSearchOffsetByUser$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}> {
    return this.lpInspectionControllerSearchOffsetByUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}>): OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
} => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerSearchSimpleOffsetByParent()` */
  static readonly LpInspectionControllerSearchSimpleOffsetByParentPath = '/api/lp-inspection/search/offset/parent';

  /**
   * 부모 앱에서 LP검사 단순 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerSearchSimpleOffsetByParent()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerSearchSimpleOffsetByParent$Response(params: LpInspectionControllerSearchSimpleOffsetByParent$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}>> {
    return lpInspectionControllerSearchSimpleOffsetByParent(this.http, this.rootUrl, params, context);
  }

  /**
   * 부모 앱에서 LP검사 단순 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerSearchSimpleOffsetByParent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerSearchSimpleOffsetByParent(params: LpInspectionControllerSearchSimpleOffsetByParent$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}> {
    return this.lpInspectionControllerSearchSimpleOffsetByParent$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}>): OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
} => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerIsCompleteLp1()` */
  static readonly LpInspectionControllerIsCompleteLp1Path = '/api/lp-inspection/complete-LP1/{childId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerIsCompleteLp1()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerIsCompleteLp1$Response(params: LpInspectionControllerIsCompleteLp1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return lpInspectionControllerIsCompleteLp1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerIsCompleteLp1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerIsCompleteLp1(params: LpInspectionControllerIsCompleteLp1$Params, context?: HttpContext): Observable<boolean> {
    return this.lpInspectionControllerIsCompleteLp1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerGetStat()` */
  static readonly LpInspectionControllerGetStatPath = '/api/lp-inspection/{id}/nd';

  /**
   * 검사 결과 표준분포 조회.
   *
   * 입력한 기준에 따른 검사 결과의 표준분포를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerGetStat()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGetStat$Response(params: LpInspectionControllerGetStat$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LpInspectionSeriesItemDto>>> {
    return lpInspectionControllerGetStat(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 결과 표준분포 조회.
   *
   * 입력한 기준에 따른 검사 결과의 표준분포를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerGetStat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGetStat(params: LpInspectionControllerGetStat$Params, context?: HttpContext): Observable<Array<LpInspectionSeriesItemDto>> {
    return this.lpInspectionControllerGetStat$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LpInspectionSeriesItemDto>>): Array<LpInspectionSeriesItemDto> => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerFindById()` */
  static readonly LpInspectionControllerFindByIdPath = '/api/lp-inspection/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerFindById$Response(params: LpInspectionControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return lpInspectionControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerFindById(params: LpInspectionControllerFindById$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.lpInspectionControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerOverwrite()` */
  static readonly LpInspectionControllerOverwritePath = '/api/lp-inspection/{id}';

  /**
   * 검사 결과 수정.
   *
   * 검사 결과를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerOverwrite()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionControllerOverwrite$Response(params: LpInspectionControllerOverwrite$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return lpInspectionControllerOverwrite(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 결과 수정.
   *
   * 검사 결과를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerOverwrite$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionControllerOverwrite(params: LpInspectionControllerOverwrite$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.lpInspectionControllerOverwrite$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerReInspect()` */
  static readonly LpInspectionControllerReInspectPath = '/api/lp-inspection/{id}/re-inspect';

  /**
   * 재검사.
   *
   * 재검사가 가능한지 여부를 조회하고 검사를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerReInspect()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerReInspect$Response(params: LpInspectionControllerReInspect$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return lpInspectionControllerReInspect(this.http, this.rootUrl, params, context);
  }

  /**
   * 재검사.
   *
   * 재검사가 가능한지 여부를 조회하고 검사를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerReInspect$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerReInspect(params: LpInspectionControllerReInspect$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.lpInspectionControllerReInspect$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerGetPcczScore()` */
  static readonly LpInspectionControllerGetPcczScorePath = '/api/lp-inspection/{id}/zscore';

  /**
   * 검사 결과 Z-점수 조회.
   *
   * 입력한 기준에 따른 검사 결과의 Z-점수를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerGetPcczScore()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGetPcczScore$Response(params: LpInspectionControllerGetPcczScore$Params, context?: HttpContext): Observable<StrictHttpResponse<PcczScoreDto>> {
    return lpInspectionControllerGetPcczScore(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 결과 Z-점수 조회.
   *
   * 입력한 기준에 따른 검사 결과의 Z-점수를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerGetPcczScore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGetPcczScore(params: LpInspectionControllerGetPcczScore$Params, context?: HttpContext): Observable<PcczScoreDto> {
    return this.lpInspectionControllerGetPcczScore$Response(params, context).pipe(
      map((r: StrictHttpResponse<PcczScoreDto>): PcczScoreDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerCreate()` */
  static readonly LpInspectionControllerCreatePath = '/api/lp-inspection/start';

  /**
   * 검사를 시작합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionControllerCreate$Response(params: LpInspectionControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return lpInspectionControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사를 시작합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionControllerCreate(params: LpInspectionControllerCreate$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.lpInspectionControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerAddWord()` */
  static readonly LpInspectionControllerAddWordPath = '/api/lp-inspection/{id}/word';

  /**
   * 단어 추가.
   *
   * 검사에 단어를 추가합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerAddWord()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  lpInspectionControllerAddWord$Response(params: LpInspectionControllerAddWord$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'valid': boolean;
'pass': boolean;
}>> {
    return lpInspectionControllerAddWord(this.http, this.rootUrl, params, context);
  }

  /**
   * 단어 추가.
   *
   * 검사에 단어를 추가합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerAddWord$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  lpInspectionControllerAddWord(params: LpInspectionControllerAddWord$Params, context?: HttpContext): Observable<{
'valid': boolean;
'pass': boolean;
}> {
    return this.lpInspectionControllerAddWord$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'valid': boolean;
'pass': boolean;
}>): {
'valid': boolean;
'pass': boolean;
} => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerComplete()` */
  static readonly LpInspectionControllerCompletePath = '/api/lp-inspection/{id}/complete';

  /**
   * 검사 완료.
   *
   * 검사을 완료합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerComplete()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerComplete$Response(params: LpInspectionControllerComplete$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return lpInspectionControllerComplete(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 완료.
   *
   * 검사을 완료합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerComplete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerComplete(params: LpInspectionControllerComplete$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.lpInspectionControllerComplete$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerGenerateReport()` */
  static readonly LpInspectionControllerGenerateReportPath = '/api/lp-inspection/{id}/report';

  /**
   * 검사 결과 리포트 생성.
   *
   * 검사 결과 리포트를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerGenerateReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGenerateReport$Response(params: LpInspectionControllerGenerateReport$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return lpInspectionControllerGenerateReport(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 결과 리포트 생성.
   *
   * 검사 결과 리포트를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerGenerateReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerGenerateReport(params: LpInspectionControllerGenerateReport$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.lpInspectionControllerGenerateReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerInvalidateResults()` */
  static readonly LpInspectionControllerInvalidateResultsPath = '/api/lp-inspection/{id}/invalidate';

  /**
   * 검사 결과 무효화.
   *
   * 검사 결과를 모두 무효화합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerInvalidateResults()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerInvalidateResults$Response(params: LpInspectionControllerInvalidateResults$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return lpInspectionControllerInvalidateResults(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 결과 무효화.
   *
   * 검사 결과를 모두 무효화합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerInvalidateResults$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerInvalidateResults(params: LpInspectionControllerInvalidateResults$Params, context?: HttpContext): Observable<void> {
    return this.lpInspectionControllerInvalidateResults$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerRestore()` */
  static readonly LpInspectionControllerRestorePath = '/api/lp-inspection/{id}/restore';

  /**
   * 검사 결과 복구.
   *
   * 관리자에 의해 수정된 검사 결과를 복구합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerRestore$Response(params: LpInspectionControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return lpInspectionControllerRestore(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 결과 복구.
   *
   * 관리자에 의해 수정된 검사 결과를 복구합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerRestore(params: LpInspectionControllerRestore$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.lpInspectionControllerRestore$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerExit()` */
  static readonly LpInspectionControllerExitPath = '/api/lp-inspection/{id}/exit';

  /**
   * 검사 종료.
   *
   * 검사를 종료합니다. (의도적 종료, 비의도적 종료)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerExit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionControllerExit$Response(params: LpInspectionControllerExit$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return lpInspectionControllerExit(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 종료.
   *
   * 검사를 종료합니다. (의도적 종료, 비의도적 종료)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerExit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionControllerExit(params: LpInspectionControllerExit$Params, context?: HttpContext): Observable<boolean> {
    return this.lpInspectionControllerExit$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `lpInspectionControllerHeartbeat()` */
  static readonly LpInspectionControllerHeartbeatPath = '/api/lp-inspection/{id}/heartbeat';

  /**
   * 검사 하트비트.
   *
   * 검사 진행 중 생존 신호를 보냅니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionControllerHeartbeat()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerHeartbeat$Response(params: LpInspectionControllerHeartbeat$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return lpInspectionControllerHeartbeat(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 하트비트.
   *
   * 검사 진행 중 생존 신호를 보냅니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionControllerHeartbeat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionControllerHeartbeat(params: LpInspectionControllerHeartbeat$Params, context?: HttpContext): Observable<boolean> {
    return this.lpInspectionControllerHeartbeat$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
